import { TABLET_API_ORIGIN } from '@/global/env';
import { RestClientInterface } from '@/lib/restClient';
import { UberStoreListResponse } from '@/services/StoreManagement/UberStores/hooks/useStoreManagementUberStoreList';

interface Interface {
  list: (code: string) => Promise<UberStoreListResponse[]>;
}

export class StoreManagementUberStoreService implements Interface {
  constructor(private readonly restClient: RestClientInterface) {}

  public async list(code: string): Promise<UberStoreListResponse[]> {
    return await this.restClient.get<UberStoreListResponse[]>(
      `${TABLET_API_ORIGIN}/dashboard-api/oauth/uber/stores?code=${code}` as const
    );
  }
}
